import questionnaire from './questionnaire';
import strategy from './strategy';
import test from './test';
import health from './health';
import conclusion from './conclusion';
import note from './note';

export default {
  questionnaire,
  strategy,
  test,
  health,
  conclusion,
  note,
};
